import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Update an option
export const updateOption = async (key, dto) => {
  try {
    const response = await axiosInstance.put(`${API_ROUTES.OPTIONS.UPDATE}/${key}`, dto);
    return response.data;
  } catch (error) {
    console.error('Error updating option:', error);
    throw error;
  }
};

// Get an option by key
export const getOption = async (key) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.OPTIONS.GET}/${key}`);
    return response.data;
  } catch (error) {
    console.error('Error getting option:', error);
    throw error;
  }
};

const optionsApi = {
  updateOption,
};

export default optionsApi;